
import { jwtDecode } from 'jwt-decode';

type AccessTokenClaims = {
    tenantUrl?: string;
    [key: string]: unknown;
};


export function getTenantUrlFromAccessToken(token?: string | null): string | null {
    if (!token) return null;

    try {
        const claims = jwtDecode<AccessTokenClaims>(token);
        return typeof claims.tenantUrl === 'string'
            ? claims.tenantUrl
            : typeof claims.tenant_url === 'string'
                ? claims.tenant_url
                : null;
    } catch {
        return null;
    }
}
